var _defs, _path, _path2, _path3, _path4, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmallRingLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "LOGO",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "31.66 32.16 113.34 113.34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-2{stroke-width:0;fill:#50bfd0}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M88.33 32.16c-31.25 0-56.67 25.42-56.67 56.67s25.42 56.67 56.67 56.67S145 120.08 145 88.83s-25.42-56.67-56.67-56.67m0 111C58.37 143.16 34 118.79 34 88.83S58.37 34.5 88.33 34.5s54.33 24.37 54.33 54.33-24.37 54.33-54.33 54.33"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M88.33 43.74c-24.87 0-45.09 20.23-45.09 45.09s20.23 45.09 45.09 45.09 45.09-20.23 45.09-45.09-20.23-45.09-45.09-45.09m0 86.7c-22.94 0-41.61-18.66-41.61-41.61s18.66-41.61 41.61-41.61 41.61 18.66 41.61 41.61-18.66 41.61-41.61 41.61"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M88.33 55.31c-18.48 0-33.52 15.04-33.52 33.52s15.04 33.52 33.52 33.52 33.52-15.04 33.52-33.52-15.04-33.52-33.52-33.52m0 62.41c-15.93 0-28.89-12.96-28.89-28.89S72.4 59.94 88.33 59.94s28.89 12.96 28.89 28.89-12.96 28.89-28.89 28.89"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M88.33 66.88c-12.1 0-21.95 9.85-21.95 21.95s9.85 21.95 21.95 21.95 21.95-9.85 21.95-21.95-9.85-21.95-21.95-21.95m0 38.12c-8.92 0-16.17-7.25-16.17-16.17s7.25-16.17 16.17-16.17 16.17 7.25 16.17 16.17S97.25 105 88.33 105"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 88.33,
    cy: 88.83,
    r: 10.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallRingLogo);
export default __webpack_public_path__ + "static/media/SmallRingLogo.24b1eb8e82803d3c3adfe22d14bf92c7.svg";
export { ForwardRef as ReactComponent };